// extracted by mini-css-extract-plugin
export default {"stripe-div":"stripe_stripe-div__XDfFY","success":"stripe_success__OmErv","testing":"stripe_testing__3o6yF","payment-message":"stripe_payment-message__RCpNA"};